import { DraggableModal, DraggableModalProvider } from 'ant-design-draggable-modal';
import 'antd/dist/antd.css';
import 'ant-design-draggable-modal/dist/index.css';
import React from 'react';
import { Spin } from 'antd';
import './qrModal.less';
import ImageComponent from '../map-image';

type ModalProps = {
  visible: boolean;
  handler: () => void;
  value: Blob | undefined;
  isLoading: boolean;
  qrValue: number | undefined;
  initialHeight: number | undefined;
};

const Modal = (props: ModalProps): JSX.Element => {
  const {
    visible,
    handler,
    value,
    isLoading,
    qrValue,
    initialHeight,
  } = props;
  return (
    <DraggableModalProvider>
      <DraggableModal
        open={visible}
        cancelButtonProps={{ style: { display: 'none' } }}
        onCancel={handler}
        onOk={handler}
        okText="Close"
        initialWidth={400}
        initialHeight={initialHeight || 600}
      >
        <Spin style={{ paddingTop: '600px' }} spinning={isLoading} size="large">
          <div className="wrapper-qr">
            <pre>
              <ImageComponent
                imageBlob={value}
                altText="test"
                imageSrc=""
              />
              { qrValue ? <div className="qr-value">{qrValue}</div> : '' }
            </pre>
          </div>
        </Spin>
      </DraggableModal>
    </DraggableModalProvider>
  );
};
export default Modal;
